import http from "@/settings/apiSettings"

class ConBilantFormuleDataService{
  save(data: any): Promise<any> {
        return http.clientContabilitate.post("/CON_BilantFormule", data);
      }
  
}
export default new ConBilantFormuleDataService();